import * as moment from 'moment';
import {
  NextWorkingDayActionTypes,
  NextWorkingDayActionActions,
} from '../../../../shared/modules/common-specification/actions/next-working-day.actions';

export interface State {
  nextWorkingDay: Date;
}

export const initialState: State = {
  nextWorkingDay: null,
};

export function reducer(state = initialState, action: NextWorkingDayActionActions): State {
  switch (action.type) {
    case NextWorkingDayActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        nextWorkingDay: action.payload.date,
      } as State;
    }
    case NextWorkingDayActionTypes.LOAD_CUT_OF_TIME_COMPLETE: {
      return {
        ...state,
        nextWorkingDay: moment(action.payload.dateAvailable).toDate(),
      } as State;
    }
    case NextWorkingDayActionTypes.RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
